import 'emoji-mart/css/emoji-mart.css';
import 'antd/dist/reset.css';
import './App.scss';

import { GoogleOAuthProvider } from '@react-oauth/google';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React, { StrictMode, Suspense } from 'react';
import Div100vh from 'react-div-100vh';
import { RecoilRoot } from 'recoil';

import { google } from './config/externalServices';
import { FeatureProvider } from './contexts/feature';
import { useIdle } from './hooks/useIdle';
import { MeMessagesProvider } from './hooks/useMeMessages';
import MainView from './pages/MainView/MainView';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: true
    }
  }
});

const App = () => {
  useIdle(1000 * 60 * 5);
  return (
    <StrictMode>
      <FeatureProvider>
        <GoogleOAuthProvider clientId={google.oauthClientId} ux_mode="redirect">
          <RecoilRoot>
            <QueryClientProvider client={queryClient}>
              <MeMessagesProvider>
                <Div100vh id="customDiv100ID">
                  <div className="App">
                    <Suspense fallback={<div className="SuspenseLoader">Loading...</div>}>
                      <MainView />
                    </Suspense>
                  </div>
                </Div100vh>
                {process.env.NODE_ENV === 'development' && (
                  <ReactQueryDevtools initialIsOpen={false} />
                )}
              </MeMessagesProvider>
            </QueryClientProvider>
          </RecoilRoot>
        </GoogleOAuthProvider>
      </FeatureProvider>
    </StrictMode>
  );
};

export default App;
